interface LogoIconProps {
  className?: string;
  size?: number;
}

export function LogoIcon({ className = "", size = 24 }: LogoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background con gradiente elegante per tema dark */}
      <defs>
        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#111827" />
          <stop offset="100%" stopColor="#1F2937" />
        </linearGradient>
        <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F59E0B" />
          <stop offset="100%" stopColor="#FCD34D" />
        </linearGradient>
        <linearGradient id="wineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#991B1B" />
          <stop offset="100%" stopColor="#DC2626" />
        </linearGradient>
      </defs>

      {/* Background principale */}
      <rect width="32" height="32" rx="6" fill="url(#bgGradient)" />

      {/* Bordo elegante con ombra */}
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="5"
        stroke="url(#goldGradient)"
        strokeWidth="1.5"
        fill="none"
      />

      {/* Dispositivo IQOS stilizzato */}
      <rect
        x="8"
        y="6"
        width="16"
        height="20"
        rx="3"
        fill="#2A2A2A"
        stroke="url(#goldGradient)"
        strokeWidth="1"
      />

      {/* Display principale */}
      <rect x="9" y="7" width="14" height="8" rx="2" fill="#000000" />

      {/* Indicatori LED professionali */}
      <circle cx="12" cy="9" r="1" fill="#00FF88" />
      <circle cx="16" cy="9" r="1" fill="#FF6B35" />
      <circle cx="20" cy="9" r="1" fill="url(#goldGradient)" />

      {/* Pulsante centrale elegante */}
      <circle cx="16" cy="15" r="3" fill="url(#goldGradient)" />
      <circle cx="16" cy="15" r="2" fill="#1A1A1A" />
      <circle cx="16" cy="15" r="1" fill="url(#goldGradient)" opacity="0.6" />

      {/* Bicchiere di vino integrato */}
      <path
        d="M10 22L11 20H21L22 22C22 23 21 24 20 24H12C11 24 10 23 10 22Z"
        fill="none"
        stroke="url(#goldGradient)"
        strokeWidth="1.2"
      />

      {/* Liquido del vino con gradiente */}
      <path
        d="M10.5 22L11.5 20.5H20.5L21.5 22C21.5 22.5 21 23 20 23H12C11 23 10.5 22.5 10.5 22Z"
        fill="url(#wineGradient)"
        opacity="0.9"
      />

      {/* Bollicine di vino animate */}
      <circle cx="13" cy="21" r="0.4" fill="#FFD700" />
      <circle cx="17" cy="21.5" r="0.4" fill="#FFD700" />
      <circle cx="15" cy="22" r="0.3" fill="#FFD700" />

      {/* Elemento AI moderno */}
      <circle cx="26" cy="6" r="5" fill="url(#goldGradient)" />
      <text
        x="26"
        y="9"
        textAnchor="middle"
        fill="#1A1A1A"
        fontSize="6"
        fontWeight="bold"
        fontFamily="Arial, sans-serif"
      >
        AI
      </text>

      {/* Accenti decorativi eleganti */}
      <line
        x1="3"
        y1="8"
        x2="7"
        y2="8"
        stroke="url(#goldGradient)"
        strokeWidth="0.8"
      />
      <line
        x1="3"
        y1="10"
        x2="5"
        y2="10"
        stroke="url(#goldGradient)"
        strokeWidth="0.8"
      />

      {/* Effetto vapore sofisticato */}
      <path
        d="M16 4C16 4 15 3 14 4C13 5 14 6 16 6C18 6 19 5 18 4C17 3 16 4 16 4Z"
        fill="url(#goldGradient)"
        opacity="0.7"
      />
      <path
        d="M16 3C16 3 15.5 2.5 15 3C14.5 3.5 15 4 16 4C17 4 17.5 3.5 17 3C16.5 2.5 16 3 16 3Z"
        fill="url(#goldGradient)"
        opacity="0.5"
      />

      {/* Riflessi di luce */}
      <rect
        x="9"
        y="8"
        width="1"
        height="6"
        fill="url(#goldGradient)"
        opacity="0.3"
      />
      <circle cx="16" cy="15" r="0.5" fill="#FFFFFF" opacity="0.8" />
    </svg>
  );
}
